
import { Component, Vue } from 'vue-property-decorator'
import { NewsService } from '@/services'
import RecommendTable from './components/recommendTable.vue'

@Component({
    name: 'setting-recommend-news',
    components: {
        RecommendTable
    }
})
export default class extends Vue {
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private newsList: any = []

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
    }

    private mounted() {
        this.getRecommendNews()
    }

    private async getRecommendNews() {
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await NewsService.getRecommendNewsList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.newsList = result.data.list
        }
    }

    private onDelete(news: any) {
        this.$confirm('此操作将删除该条推荐新闻, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteRecommendNews(news)
        })
    }

    private async deleteRecommendNews(news: any) {
        const params = { id: news.id }
        this.isLoading = true
        const result = await NewsService.deleteRecommendNews(params)
        this.isLoading = false
        if (result.status === 200) {
            this.newsList.splice(this.newsList.indexOf(news), 1)
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 删除失败',
            showClose: true
        })
    }

    private addRecommendNews() {
        const { href } = this.$router.resolve({
            name: 'NewsList',
            query: {
                recommend: String(1)
            }
        })
        window.open(href, '_blank')
    }
}
